import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { Container, Paper, Box, Typography, TextField, Button, Avatar, Alert, CircularProgress } from "@mui/material";
import { Lock as LockIcon } from "@mui/icons-material";
import { deepPurple } from "@mui/material/colors";
import { verifyCode } from "../services/auth";

const VerifyCode = () => {
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    // Get email from navigation state or query string
    const stateEmail = location.state?.email;
    const params = new URLSearchParams(location.search);
    const queryEmail = params.get("email");
    setEmail(stateEmail || queryEmail || "");
  }, [location]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !code) {
      setError("Enter the verification code");
      return;
    }
    setLoading(true);
    setError("");
    setSuccess("");
    try {
      const res = await verifyCode(email, code);
      if (res && res.access_token) {
        setSuccess("Verification successful. Redirecting...");
        // Use full-page navigation to avoid "The operation is insecure" (history.replace blocked in some HTTPS contexts)
        const base = window.location.pathname.startsWith("/portal") ? "/portal" : "";
        window.location.href = base + "/dashboard";
        return;
      } else {
        setError("Invalid verification response");
      }
    } catch (err) {
      setError(err.message || "Verification failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box sx={{ mt: 8, display: "flex", flexDirection: "column", alignItems: "center" }}>
        <Paper elevation={3} sx={{ p: 4, width: "100%", borderRadius: 2 }}>
          <Avatar sx={{ bgcolor: deepPurple[500], mb: 2, mx: "auto", width: 56, height: 56 }}>
            <LockIcon />
          </Avatar>
          <Typography component="h1" variant="h5" align="center" sx={{ mb: 2 }}>
            Enter Verification Code
          </Typography>
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
          <Box component="form" onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Email"
              margin="normal"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled
            />
            <TextField
              fullWidth
              label="Verification Code"
              margin="normal"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              autoFocus
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 2 }}
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} /> : "Verify"}
            </Button>
            <Box sx={{ mt: 2, textAlign: "center" }}>
              <Link to="/">Back to Login</Link>
            </Box>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default VerifyCode;


